define('collections/questionnaire/questions',[
    'underscore',
    'backbone',
    'utils',
    // services
    'services/api',
    // models
    'models/questionnaire/question'
], function(
    _, Backbone, U,
    // services
    API,
    // models
    MQuestion
) {

    var CQuestions = Backbone.Collection.extend({
        model: MQuestion,

        set: function(models, opt) {
            models = CQuestions.__super__.set.call(this, models, opt);
            //this.updatePositions(opt);
            return models;
        },

        remove: function(models, opt) {
            models = CQuestions.__super__.remove.call(this, models, opt);
            //this.updatePositions(opt);
            return models;
        },

        move: function(fromIndex, toIndex, options) {
            if (fromIndex === toIndex) return this;
            var item = this.at(fromIndex);
            // use the native remove to avoid calling updatePositions twice.
            CQuestions.__super__.remove.call(this, item, { silent: true });
            this.add(item, _.extend({ at: toIndex }, options));

            return this;
        },

        // updatePositions: function(options) {
        //     this.each(function(model, index) {
        //         model.updatePosition(index, options);
        //     }, this);
        // },
    });

    return CQuestions;

});

